var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#3872A3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1989 111V41.1818H107.381C112.744 41.1818 117.244 42.1818 120.881 44.1818C124.54 46.1818 127.301 48.9318 129.165 52.4318C131.051 55.9091 131.994 59.8636 131.994 64.2955C131.994 68.7727 131.051 72.75 129.165 76.2273C127.278 79.7045 124.494 82.4432 120.812 84.4432C117.131 86.4205 112.597 87.4091 107.21 87.4091H89.858V77.0114H105.506C108.642 77.0114 111.21 76.4659 113.21 75.375C115.21 74.2841 116.688 72.7841 117.642 70.875C118.619 68.9659 119.108 66.7727 119.108 64.2955C119.108 61.8182 118.619 59.6364 117.642 57.75C116.688 55.8636 115.199 54.3977 113.176 53.3523C111.176 52.2841 108.597 51.75 105.438 51.75H93.8466V111H81.1989ZM138.207 41.1818H152.491L169.571 72.0682H170.253L187.332 41.1818H201.616L176.219 84.9545V111H163.605V84.9545L138.207 41.1818Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.575 194C176.55 194 175.916 216.911 175.916 221.627C175.916 228.782 175.916 250.25 175.916 250.25H236.711V258.843C236.711 258.843 173.411 258.843 151.768 258.843C133.702 258.843 111 269.827 111 318.502C111 363.214 128.709 380.505 146.582 380.505C151.889 380.505 167.818 380.505 167.818 380.505C167.818 380.505 167.818 358.311 167.818 350.675C167.818 338.195 174.002 315.093 202.832 315.093C238.991 315.093 248.22 315.093 263.13 315.093C271.998 315.093 297.007 311.239 297.007 282.352C297.007 251.78 297.007 241.693 297.007 227.309C297.009 220.143 295.784 194 235.575 194ZM202.052 213.248C208.102 213.248 212.991 218.134 212.991 224.186C212.991 230.234 208.102 235.125 202.052 235.125C196.002 235.125 191.114 230.236 191.114 224.186C191.114 218.134 196.002 213.248 202.052 213.248Z",
    fill: "url(#paint0_linear_106_821)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.426 444.001C295.424 444.001 296.158 420.657 296.158 416.373C296.158 409.219 296.158 387.751 296.158 387.751H235.29V379.157C235.29 379.157 298.999 379.157 320.233 379.157C338.435 379.157 361.001 367.898 361.001 319.498C361.001 266.494 337.051 257.496 325.419 257.496C320.11 257.496 304.183 257.496 304.183 257.496C304.183 257.496 304.183 280.714 304.183 287.326C304.183 299.805 298.204 322.907 269.169 322.907C233.01 322.907 224.906 322.907 208.869 322.907C200.024 322.907 174.992 327.217 174.992 355.648C174.992 388.546 174.992 397.16 174.992 410.692C174.992 422.578 182.256 444.001 236.426 444.001ZM269.951 424.753C263.901 424.753 259.013 419.864 259.013 413.814C259.013 407.764 263.899 402.876 269.951 402.876C275.999 402.876 280.89 407.764 280.89 413.814C280.89 419.864 275.999 424.753 269.951 424.753Z",
    fill: "url(#paint1_linear_106_821)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_821",
    x: 69.1992,
    y: 41.1836,
    width: 136.418,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_821",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_821",
    x1: 134.428,
    y1: 216.332,
    x2: 258.695,
    y2: 341.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_821",
    x1: 209.949,
    y1: 295.994,
    x2: 343.181,
    y2: 423.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(111 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/py.d728e318ecc4d88c06c3b020c07d7a8c.svg";
export { ForwardRef as ReactComponent };